// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import Container from 'components/Container';
import Checkbox from 'components/Checkbox';
import LargeCheckbox from 'components/LargeCheckbox';
import { partial } from 'utils/functional';
import { camelCaseToDash } from 'utils/string';
import { colors, breakpoints } from '../theme';

// FIXME: this function is copied from web/components/Form/Field.js
const defaultGetQaId = name => camelCaseToDash(name).replace(/\./g, '-');

const CheckboxContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${props =>
    !props.columns &&
    css`
      flex-direction: column;
    `};
  ${props =>
    props.large &&
    css`
      margin: -6px;
    `};
  justify-content: flex-start;
  border-radius: 4px;
  @media (min-width: ${breakpoints[2]}) {
    flex-direction: row;
  }
  ${props =>
    props.hasError &&
    css`
      border: solid 1px ${colors.scarlet};
      box-shadow: 0 0 0 1px ${colors.scarlet};
      padding-right: 15px;
      padding-left: 15px;
    `};
`;

const Checkboxes = ({
  id,
  name,
  getValue,
  options,
  columns,
  hasError,
  onChange,
  disabled,
  large,
  getQaId,
  ...props
}: {
  id?: string,
  name?: string,
  getValue: string => mixed,
  options: Array<{ label: string, name: string }>,
  columns?: 1 | 2,
  hasError?: boolean,
  onChange: (string, boolean) => void,
  disabled?: boolean,
  large?: boolean,
  getQaId?: Function,
  'data-qa-id': string
}) => {
  const CheckboxComponent = React.useMemo(
    () => (large ? LargeCheckbox : Checkbox),
    [large]
  );
  const getCheckboxQaId = getQaId || defaultGetQaId;
  return (
    <CheckboxContainer
      columns={columns}
      large={large}
      hasError={hasError}
      data-qa-id={props['data-qa-id']}
    >
      {options.map(({ label: checkboxLabel, name: checkboxName }, index) => (
        <Container
          key={checkboxName.toString()}
          pr={!columns && !large && index !== options.length - 1 ? '50px' : 0}
          p={large && '6px'}
          width={columns && [1, 1, 1 / columns]}
        >
          <CheckboxComponent
            name={checkboxName}
            label={checkboxLabel}
            id={
              index === 0
                ? id || props['data-qa-id']
                : `${id || props['data-qa-id']}-${checkboxName}`
            }
            data-qa-id={`${props['data-qa-id']}-${getCheckboxQaId(
              checkboxName
            )}`}
            onChange={partial(onChange, checkboxName)}
            checked={Boolean(getValue(checkboxName))}
            disabled={disabled}
          />
        </Container>
      ))}
    </CheckboxContainer>
  );
};

export default Checkboxes;
